import { Logger } from '@nolimitcity/slot-launcher/bin/utils/Logger';
import { Presentation } from '../../../../core/gameflow/controller/Presentation';
import { ReelState } from '../../../../core/reel/ReelEngineView';
import { MathHelper } from '../../../../core/utils/MathHelper';
import { Beheaded } from '../../../Beheaded';
import { SoundConfig } from '../../../config/sound/SoundConfig';
import { SoundManager } from '../../../config/sound/SoundManager';
import { BeheadedEngineController } from '../../../reels/BeheadedEngineController';
import { BeheadedEngineManager } from '../../../reels/BeheadedEngineManager';
import { InitData } from '../../../server/data/InitData';
import { GameData } from '../../../server/data/GameData';
import { GameMode } from '@nolimitcity/slot-game/bin/flowcontrol/GameMode';
import { GameSetting } from '../../../../core/setting/GameSetting';
import { BeheadedGameMode } from '../../../server/data/BeheadedGameMode';
import { APIEvent } from '@nolimitcity/slot-launcher/bin/interfaces/APIEventSystem';
import { SlotGame } from '@nolimitcity/slot-game/bin/SlotGame';
import { gsap } from 'gsap';
import { Helper } from '../../../../core/utils/Helper';

export class StartPresentation extends Presentation {

    protected gameMode: string;
    private reelsCanBeStarted: boolean = false;

    private killTl:gsap.core.Timeline

    public initialization(_gameMode: string): void {
        this.gameMode = _gameMode;
    }

    protected addExtraForStart(reel: BeheadedEngineController) {

        reel.AllSticky.forEach((sym) => {
            sym.applyDropFx(reel.startDuration);
        });

        reel.markSymbolCuts(0);
    }

    preStart(): void {

        BeheadedEngineManager.onBeforeSpinStart();
        this.reelsCanBeStarted = BeheadedEngineManager.isStartAble();

        if (this.reelsCanBeStarted) {
            BeheadedEngineManager.RAll((rc: BeheadedEngineController) =>
                rc.createStart({ start: () => (this.addExtraForStart ? this.addExtraForStart(rc) : undefined) })
            );
        }
    }

    public setInitData(data: InitData): void {
        this.setGamedData(data);
    }

    public setGamedData(data: GameData): void {
    }

    createPresentation(skip?:Function) {

        this.modeBehaviour();

        Beheaded.souldWildController.soulWildRemove();

        this.startReels();

        this.PresentationState.setInactive();
    }

    modeBehaviour():void{

        if (this.gameMode === GameMode.NORMAL) {
            Beheaded.baseMultiplier.setValue(1);
            Beheaded.overlayBG.flagShow(true);

            // if (GameSetting.isBonusBet) {
            //     // const level = GameSetting.isBonusBuy ? 3 : 5;

            //     // if (Beheaded.collectorBar.currentLevel !== level) {
            //     //     Beheaded.souldWildController.forceIndicatorResets();
            //     //     Beheaded.collectorBar.forceReset();
            //     // }

            //     // Beheaded.souldWildController.enableSWindicator(level); //enable SW indicator at specified level
            //     // Beheaded.collectorBar.resetAnimationLevel(level);
            //     // Beheaded.overlayBG.upgradeBGOverlay(level);
            //     // Beheaded.background.upgradeBG(level);
            // }else

            Beheaded.souldWildController.disableIndicator();

            const resetLevel = GameSetting.isBoostedBet ? 1 : 0;

            if (Beheaded.background.currentBGLevel != resetLevel) {
                Beheaded.overlayBG.upgradeBGOverlay(resetLevel);
                Beheaded.background.upgradeBG(resetLevel);
            }

            Beheaded.collectorBar.resetAnimationLevel(resetLevel);
            Beheaded.souldWildController.deactivateIndicators();
            if(GameSetting.isBoostedBet)
                Beheaded.souldWildController.hideAllProgressionBars(GameSetting.isBoostedBet);
        }

        if (this.gameMode === GameMode.FREESPIN || this.gameMode === 'SUPER_FREESPIN') {
            Beheaded.souldWildController.deactivateIndicators();
        }
    }

    startReels(): void {
        let delay: number = 0;
        if (this.reelsCanBeStarted) {
            const startReel: number = BeheadedEngineManager.findReelWithState(ReelState.START, true);
            BeheadedEngineManager.RAll((reel) => {
                if (reel.reelID == startReel)
                    this.timeline.add(() => {
                        SoundManager.playSoundEffect(SoundConfig.REELS_OUT, 0, 1);
                    }, delay);

                this.timeline.add(() => {
                    reel.startReel();
                }, delay);
                if (reel.isActive) delay += reel.startDelay;
            });
            // if only one reel starts, there is no time delay. Need to add some duration to trigger the elements in an gsap timeline.
            this.timeline.duration() == 0 ? this.timeline.to(this, { duration: MathHelper.frameToSeconds(1) }) : null;
        } else {
            Beheaded.backgroundCharacter.animateBackgroundCharacter(true)
        }

        if (GameSetting.isBonusBet) {
            this.timeline.add(Beheaded.backgroundCharacter.animateBackgroundCharacterForFeatureBuy(true,1),"+=0.3");
        }
    }

    public fadeFinalScreenCharacter(fade: boolean = true) {
    }

    public fadeFeatureBuyCharacter(fade: boolean = true) {
    }

    skip(): void {
        BeheadedEngineManager.isQuickStop = true;
    }

    done(): void {
        Logger.logDev('StartPresentation Done');
    }
}
